import React from "react";
import { Button, Stack, Typography } from "@mui/joy";
import { FaLink, FaDownload } from "react-icons/fa6";
import {
  FaFilePdf,
  FaGithub,
  FaFilePowerpoint,
  FaFileCode,
} from "react-icons/fa";

const LinkChip = ({ title, subtitle, linkProp, href, buttonIcon }) => {
  const linkProps =
    linkProp === "download"
      ? { component: "a", href, download: true }
      : linkProp === "link"
      ? { component: "a", href, target: "_blank", rel: "noopener noreferrer" }
      : {};

  const icon = (() => {
    switch (buttonIcon) {
      case "link":
        return <FaLink size={24} />;
      case "download":
        return <FaDownload size={24} />;
      case "pdf":
        return <FaFilePdf size={24} />;
      case "pptx":
        return <FaFilePowerpoint size={24} />;
      case "github":
        return <FaGithub size={24} />;
      case "code":
        return <FaFileCode size={24} />;
      default:
        switch (linkProp) {
          case "link":
            return <FaLink size={24} />;
          case "download":
            return <FaDownload size={24} />;
          default:
            return null;
        }
    }
  })();

  const color = (() => {
    switch (linkProp) {
      case "link":
        return "#C87F0A";
      case "download":
        return "#C87F0A";
      default:
        return null;
    }
  })();

  return (
    <Button
      {...linkProps}
      variant="outlined"
      startDecorator={icon}
      color={color}
      sx={{
        borderRadius: "xl",
        justifyContent: "flex-start",
        width: "275px",
        textAlign: "left",
        alignItems: "center",
        padding: "8px 12px",
        border: `1px solid ${color}`,
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: `${color}22`,
        },
        color: color,
      }}
    >
      <Stack spacing={0.1} alignItems="flex-start">
        <Typography level="body-md" fontWeight="lg" textColor={color}>
          {title}
        </Typography>
        <Typography level="body-xs" textColor="text.tertiary">
          {linkProp === "download" ? "Download Size: " : ""}
          {subtitle}
        </Typography>
      </Stack>
    </Button>
  );
};

export default LinkChip;
